<template>
  <div class="card alert-page">
      <div class="card-header">
          <h5 class="card-title">Alert Message</h5>
          <hr>
      </div>

      <div class="card-body alert-body">
				<div>
					<div class="alert-inline">
						<div class="alert-field">
							<div style="width:225px">
								<div class="alert-field-title">
									<label>Expiration Date</label>
								</div>
								<DxDateBox
									v-model="alert.ExpirationDate"
									type="datetime"
								/>
							</div>
						</div>
					</div>
					<div class="alert-color-container alert-inline">
						<BasicDropdown label='Alert Title Background Color' :items="alertColorOptions" v-model="alert.BackgroundColor" :key="alertColorOptionsKey"/>
					</div>
					<div class="alert-inline">
						<Checkbox label="One Time Message" v-model="alert.IsOneTimeMessage"/>
					</div>
					<div class="alert-inline">
						<Checkbox label="Include on Logon Screen" v-model="alert.IncludeOnLogonScreen"/>
					</div>
				</div>

			<div class="dealer-list-container alert-field">
				<div class="alert-field-title">
					<label>Dealer List</label>
					<span class="dealer-note">(Leave empty to show to all dealers)</span>
				</div>
				<DxTagBox
					:items="dealers"
					:value="alert.DealerIds"
					@value-changed="onDealerSelectionChanged"
					display-expr="DisplayName"
					value-expr="Id"
					:show-clear-button="true"
					:search-enabled="true"
					placeholder="Select dealers..."
					:max-displayed-tags="5"
					:show-selection-controls="true"
					apply-value-mode="useButtons"
				/>
			</div>

				<div class="alert-title alert-field">
					<div class="alert-field-title">
						<label>Alert Banner Message</label>
					</div>
          <input v-model="alert.Message" maxlength="255"/>
				</div>

				<div class="alert-title alert-field">
					<div class="alert-field-title">
						<label>Alert Message Title</label>
					</div>
          <input v-model="alert.MessageTitle" maxlength="255"/>
				</div>

				<div class="message alert-field">
						<div id="editor-title">Enter Alert Message Body Here</div>
						<div id="editor">
								<textarea :value="alert.MessageBody" @input="update"></textarea>
								<div id="preview">
										<span id="preview-title">Message Preview</span>
										<br/>
										<div id="preview-area" v-html="compiledMarkdown"></div>
								</div>
						</div>
				</div>

				<div class="btn-container">
					<div @click="sendAlertMessage" class="btn btn-primary message-send-btn">Send Message</div>
				</div>
			</div>
  </div>
</template>

<script>
import SystemConfigService from '../../../services/systemConfig'
import DealerService from '../../../services/dealers'
import {DxDateBox} from 'devextreme-vue/date-box';
import moment from 'moment'
import { maxLength } from 'vuelidate/lib/validators';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxTagBox from 'devextreme-vue/tag-box';
import { marked } from 'marked';
import { gfmHeadingId } from 'marked-gfm-heading-id';

marked.use(gfmHeadingId({prefix: 'my-prefix-'}))

export default {
  name: 'AdminAlertMessage',
  components: {
    DxDateBox,
    DxDropDownBox,
    DxTagBox
  },
  data(){
    return{
      alert: {
        Message: '',
				MessageBody: '',
        ExpirationDate: new Date(),
        IsOneTimeMessage: false,
        IncludeOnLogonScreen: false,
        BackgroundColor: 'rgb(232,63,84)',
        DealerIds: []
      },
      dealers: [],
      alertColorOptions: [
        {text: 'Blue', value: 'lightblue'},
        {text: 'Green', value: 'lightgreen'},
        {text: 'Red', value: 'rgb(232,63,84)'},
        {text: 'Yellow', value: 'yellow'},
      ],
      alertColorOptionsKey: 0,
    }
  },
  mounted() {
    // Load dealers list
    this.loadDealers();

    // Load existing alert message (use unfiltered version for admin editing)
    SystemConfigService.getMessageAdmin()
      .then(res => {
        if (res) {
          this.alert = res;

          // Ensure DealerIds is an array
          if (!this.alert.DealerIds) {
            this.alert.DealerIds = [];
          }

          // convert the UTC expiration date to local date/time
          this.alert.ExpirationDate = moment.utc(this.alert.ExpirationDate)

          if (!this.alert.BackgroundColor) {
            this.alert.BackgroundColor = 'rgb(232,63,84)'
          }

          this.alertColorOptionsKey++;
        }
      })
      .catch(err => {
        console.error('Error retrieving alert:', err)
        this.$store.dispatch('ADD_NOTIFICATION', { text: `Error retrieving alert: ${err.message}`, type: 'error' });
      })
  },
  validations: {
    alert: {
      Message: {
        maxLength: maxLength(255)
      }
    }
  },
	computed: {
		compiledMarkdown() {
				return marked(this.alert.MessageBody, { sanitize: true })
		},
	},
  methods: {
		update(e) {
			this.alert.MessageBody = e.target.value;
		},
    loadDealers() {
      DealerService.all()
        .then(res => {
          this.dealers = res;
        })
        .catch(err => {
          console.error('Error loading dealers:', err);
          this.$store.dispatch('ADD_NOTIFICATION', { text: `Error loading dealers: ${err.message}`, type: 'error' });
        });
    },
    onDealerSelectionChanged(e) {
      this.alert.DealerIds = e.value || [];
    },
    sendAlertMessage(){
      this.alert.ExpirationDate = moment(this.alert.ExpirationDate).utc().format();
      SystemConfigService.putMessage(this.alert)
        .then(() => {
          this.$store.dispatch('GET_ALERT_MESSAGE');
          this.$store.dispatch('ADD_NOTIFICATION', { text: `New alert message settings saved.`, type: 'success' });
        }).catch(err => {
          console.error('Error saving alert:', err)
          this.$store.dispatch('ADD_NOTIFICATION', { text: `Error saving alert: ${err.message}`, type: 'error' });
        })
    }
  }
}
</script>

<style lang="scss" scoped>
	.alert-page {
    font-family: "Helvetica Neue", "Segoe UI", Helvetica, Verdana, sans-serif;
    font-size: 14px;
	}

	.alert-body {
		margin-left: 10px;
	}

  .btn-container {
    width: 100%;

  }

  .error {
    color: $red;
  }

  .message-send-btn {
    margin: 10px;
    float: left;
    width: 200px;
  }

  .onetime-container {
    margin-top: 25px;
    width: 200px;
    color: rgb(51,51,51);
  }

  .alert-color-container {
    width: 200px;
    color: rgb(51,51,51);
  }

	.alert-title {
		input {
			width: 900px;
		}
	}

	.alert-field {
		margin-top: 15px;
	}

	.alert-field-title {
		font-weight: 500;
	}

	.alert-inline {
		display: inline-block;
		margin-right: 25px;
	}

	#preview {
    margin-top: -24px;
    display: inline-block;
}

#preview-title {
    margin-left: 20px;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
		font-weight: 400;
}

#preview-area {
    min-width: 120%;
    outline: none;
    font-size: 14px;
    padding: 5px 20px;
    height: 45vh;
    user-select: none;
    overflow-y: auto;
    line-height: 1.2;
}

.message {
    width: 100%;
}

#editor-title {
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
		font-weight: 400;
}

#editor {
  margin: 0;
  height: 100%;
  font-family: "Helvetica Neue", Arial, sans-serif;
  color: #333;
}

textarea,
#editor div {
    display: inline-block;
    width: 45%;
    vertical-align: top;
    box-sizing: border-box;
}

textarea {
    border: none;
    border-right: 1px solid #ccc;
    border: 1px solid #ccc;
    resize: none;
    outline: none;
    background-color: #f6f6f6;
    font-size: 14px;
    font-family: "Monaco", courier, monospace;
    padding: 5px 20px;
    height: 45vh;
    overflow-y: scroll;
}

.dealer-list-container {
    margin-top: 15px;
    max-width: 500px;
}

.dealer-note {
    font-style: italic;
    color: #666;
    font-size: 12px;
    margin-left: 10px;
    font-weight: normal;
}
</style>